module.exports = __webpack_public_path__ + "static/media/slider01_sc.4a4d4a79.png";